module.exports = __webpack_public_path__ + "static/Elena-Marchiori-db59f14ccfafa0f32a07da0f1f75c4cb.jpg";